<template lang="pug">
Inode(v-bind="settings")
</template>

<script>
import ListItem from "../../ListItem.vue"
import InodeIcon from "../InodeIcon.vue"
import { mapGetters, mapState, mapMutations, mapActions } from "vuex"
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs.vue"
import Inode from "./Inode.vue"
export default {
  name: "DriveFile",
  props: {
    inode: { type: Object, required: true },
    show: {
      type: Object,
      default() {
        return {
          image: true,
          path: false,
          category: false,
          physically_created_at: true,
          inodes_count: false,
          latest_drive_file: true,
          actions: false,
        }
      },
    },
  },
  components: { Inode, Breadcrumbs, ListItem, InodeIcon },
  computed: {
    settings() {
      return {
        inode: this.inode,
        inodeLink: this.inodeLink,
        show: this.show,
      }
    },
    inodeLink() {
      return {
        name: "drive/file",
        params: { inode_id: this.inode.id },
      }
    },
    ...mapState("drive", ["inodes"]),
  },
}
</script>

<style scoped></style>
